import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['timer'];

    initialize() {
        super.initialize();

        this.timerID = undefined;
    }

    connect() {
        if (this.hasTimerTarget) {
            this.timerID = setInterval(() => this.updateTimer(), 1000);
        }
    }

    disconnect() {
        clearInterval(this.timerID);
    }

    updateTimer() {
        if (this.hasTimerTarget && this.timerTarget.dataset.date) {
            const now = new Date();
            const timeDiff = (new Date(this.timerTarget.dataset.date)) - now;

            if (timeDiff <= 0) {
                this.timerTarget.innerText = "00:00";
            } else {
                const minutes = Math.floor(timeDiff / 1000 / 60);
                const seconds = Math.floor((timeDiff / 1000) % 60);

                if (minutes >= 100) {
                    this.timerTarget.innerText = `${Math.floor(minutes / 60)} val. ${minutes % 60} min.`;
                } else {
                    this.timerTarget.innerText = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                }
            }
        }
    }
}
